import { useState } from 'react';
import { IPostWithUserAndAttachments } from '@/redux/post/post';
import { useLazyGetPostsQuery } from '@/redux/post/post.api.slice';

function useGlobalSearch({ page }: { page: number }) {
  const [query, setQuery] = useState<string>('');
  const [searchResults, setSearchResults] = useState<
    IPostWithUserAndAttachments[]
  >([]);
  const [isSearchDrawerOpen, setIsSearchDrawerOpen] = useState<boolean>(false);
  const [getPostsQuery] = useLazyGetPostsQuery();

  const handleSearch = async () => {
    const results = await getPostsQuery({
      page,
      searchQuery: query,
    }).unwrap();
    setSearchResults(results);
    setIsSearchDrawerOpen(true);
  };

  return {
    query,
    setQuery,
    searchResults,
    handleSearch,
    setIsSearchDrawerOpen,
    isSearchDrawerOpen,
  };
}

export default useGlobalSearch;
